import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, ErrorType } from '@core/api';

export const errorActions = createActionGroup({
  source: 'Error',
  events: {
    'Set Error': props<{ error: AppError; level: ErrorType }>(),
    'Clear Error': emptyProps(),
  },
});
